import "./adminMember.css";
import { getInitial } from "../../../../../../DCM/services/utils/name-utils";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Avatar,
  FormControl,
  InputLabel,
  Chip,
} from "@mui/material";

const AdminMember = ({
  admin,
  inEditingMode,
  setEditingAllMembersDetails,
  editingAllMembersDetails,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
  creatorId,
  setIsMemberUpdated,
}) => {
  const { deletingAdmins } = deletingAllMembersDetails;
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  const handleRoleChange = (e) => {
    !editingAllMembersDetails.some((member) => member.memberId === admin.id)
      ? setEditingAllMembersDetails((prev) => [
          ...prev,
          {
            previousRole: "admin",
            nextRole: e.target.value,
            memberId: admin.id,
          },
        ])
      : setEditingAllMembersDetails(
          editingAllMembersDetails.map((item) => {
            if (item.memberId === admin.id) {
              return { ...item, nextRole: e.target.value };
            } else {
              return item;
            }
          })
        );
  };

  const handleDeleteMember = () => {
    if (deletingAdmins.includes(admin.id)) {
      const newAdminsList = deletingAdmins.filter((a) => a !== admin.id);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingAdmins: newAdminsList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingAdmins: [...prev.deletingAdmins, admin.id],
      }));
    }
  };

  // ${
  //         (admin?.admin?.id === teacher_id || creatorId === admin?.admin?.id) &&
  //         inEditingMode &&
  //         "member_bg_color"
  //       }

  const getRoleColor = (role) => {
    switch (role) {
      case "admin":
        return "success";
      case "moderator":
        return "info";
      case "member":
        return "default";
      default:
        return "default";
    }
  };

  return (
    // <>
    //   <div
    //     className={`col-12 p-0 mb-1 d-flex align-items-center justify-content-between `}
    //   >
    //     <div className="col-7 p-0 mt-3 gap-2 d-flex align-items-center ">
    //       <div className="member_account_img d-flex align-items-center justify-content-center">
    //       <div className="imgPic">
    //                 <div className="initialsPic">
    //                     {getInitial(admin?.admin?.name)}
    //                 </div>
    //             </div>
    //       </div>
    //       <span className="">{admin?.admin?.name}</span>
    //       {admin?.admin?.id === teacher_id && (
    //         <span className="you">(you)</span>
    //       )}
    //       {creatorId === admin?.admin?.id && (
    //         <span className="you">(creator)</span>
    //       )}
    //     </div>
    //     {inEditingMode ? (
    //       <div className="gap-3 d-flex">
    //         {admin?.admin.id !== teacher_id &&
    //         creatorId !== admin?.admin?.id ? (
    //           <Form.Select
    //             onChange={(e) => handleRoleChange(e)}
    //             className={`${
    //               editingAllMembersDetails.some(
    //                 (member) => member.memberId === admin.id
    //               ) && `select_option_change`
    //             } custom-select`}
    //             size="sm"
    //           >
    //             <option value="admin">Admin</option>
    //             <option value="moderator">Moderator</option>
    //             <option value="member">Member</option>
    //           </Form.Select>
    //         ) : (
    //           <span>ADMIN</span>
    //         )}
    //         {!deletingAdmins.includes(admin.id) ? (
    //           <>
    //             {admin?.admin.id !== teacher_id &&
    //               creatorId !== admin?.admin?.id && (
    //                 <img
    //                   onClick={handleDeleteMember}
    //                   src="/images/Dustbin.svg"
    //                   alt=""
    //                 />
    //               )}
    //           </>
    //         ) : (
    //           <img
    //             onClick={handleDeleteMember}
    //             src="/images/redDustbin.svg"
    //             alt=""
    //           />
    //         )}
    //       </div>
    //     ) : (
    //       <span>Admin</span>
    //     )}
    //   </div>
    // </>

    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        py: 1,
        mt: 1,
        borderBottom: "1px solid #eee",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar sx={{ bgcolor: "orange", width: 40, height: 40, fontSize: 16 }}>
          {getInitial(admin?.admin?.name)}
        </Avatar>
        <Box>
          <Typography variant="body1" fontWeight={500} className="d-flex gap-2">
            {admin?.admin?.name}{" "}
            {admin?.admin?.id === teacher_id && (
              <Chip
                label="You"
                size="small"
                color="primary"
                variant="outlined"
                sx={{ borderRadius: "12px", fontSize: "0.75rem" }}
              />
            )}
            {creatorId === admin?.admin?.id && (
              <Chip
                label="Creator"
                size="small"
                color="warning"
                variant="outlined"
                sx={{ borderRadius: "12px", fontSize: "0.75rem" }}
              />
            )}
          </Typography>
        </Box>
      </Box>

      {inEditingMode ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {admin?.admin.id !== teacher_id && creatorId !== admin?.admin?.id ? (
            <FormControl size="small" variant="outlined" sx={{ minWidth: 120 }}>
              <Select
                value={
                  editingAllMembersDetails.find((m) => m.memberId === admin.id)
                    ?.nextRole || "admin"
                }
                onChange={(e) => {
                  handleRoleChange(e);
                  setIsMemberUpdated(true);
                }}
                sx={{
                  borderColor: editingAllMembersDetails.some(
                    (member) => member.memberId === admin.id
                  )
                    ? "orange"
                    : "inherit",
                }}
              >
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="moderator">Moderator</MenuItem>
                <MenuItem value="member">Member</MenuItem>
              </Select>
            </FormControl>
          ) : (
            <Chip
              label={admin.role[0].toUpperCase() + admin.role.slice(1)}
              size="small"
              color={getRoleColor(admin.role)}
              variant="outlined"
              sx={{
                borderRadius: "12px",
                fontSize: "0.75rem",
                px: 1.5,
                marginRight: 2,
              }}
            />
          )}

          {admin?.admin.id !== teacher_id && creatorId !== admin?.admin?.id ? (
            <Box
              component="img"
              src={
                deletingAdmins.includes(admin.id)
                  ? "/images/redDustbin.svg"
                  : "/images/Dustbin.svg"
              }
              alt="Delete"
              sx={{ width: 24, height: 24, cursor: "pointer" }}
              onClick={() => {
                handleDeleteMember();
                setIsMemberUpdated(true);
              }}
            />
          ) : null}
        </Box>
      ) : (
        <Chip
          label={admin.role[0].toUpperCase() + admin.role.slice(1)}
          size="small"
          color={getRoleColor(admin.role)}
          variant="outlined"
          sx={{
            borderRadius: "12px",
            fontSize: "0.75rem",
            px: 1.5,
            marginRight: 2,
          }}
        />
      )}
    </Box>
  );
};

export default AdminMember;
